// extracted by mini-css-extract-plugin
module.exports = {"ducks":"Ticker_ducks__HwpG4","text":"Ticker_text__3E5qT"};